module.exports = __webpack_public_path__ + "static/media/Ellipse-who.76d7be15.png";